import "../marketplace-layout.css";

const MarketplacePage = ({ children, className = "" }) => (
  <div className={`marketplace-page ${className}`.trim()}>
    <div className="marketplace-container">{children}</div>
  </div>
);

export default MarketplacePage;
